/*
 * Description  :
 * Date         :2021-11-01 14:02:38
 * LastEditors  :chenjia
 * LastEditTime :2022-06-23 10:08:51
 * FilePath     :\abackup-pay\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      payType: sessionStorage.payType ? JSON.parse(sessionStorage.getItem('payType')) :[],//支付方式得购买详情信息
      userEmail:sessionStorage.userEmail ? sessionStorage.getItem('userEmail') : '',
      orderInfo: sessionStorage.orderInfo ? JSON.parse(sessionStorage.getItem('orderInfo')) : null,//成功之后得订单详情
      payOrderNumberoList: sessionStorage.payOrderNumberoList ? JSON.parse(sessionStorage.getItem('payOrderNumberoList')) : [], // 切换产生得所有订单号数组
      user: sessionStorage.user ? JSON.parse(sessionStorage.getItem('user')) : {}
    },
  mutations: {
    updateOrderInfo(state, val) {
      state.orderInfo = val;
      sessionStorage.setItem('orderInfo', JSON.stringify(state.orderInfo));
    },
    setOrderNumberList(state, val){
        state.payOrderNumberoList.indexOf(val)===-1 && state.payOrderNumberoList.push(val);
        sessionStorage.setItem('payOrderNumberoList', JSON.stringify(state.payOrderNumberoList))
    },
    delOrderNumberList(state){
        state.payOrderNumberoList = [];
        sessionStorage.removeItem('payOrderNumberoList');
    },
    updateEmail(state, val) {
      state.userEmail = val;
      sessionStorage.setItem('userEmail', state.userEmail);
    },
    setPayType(state, val) {
      state.payType.push(val);
      sessionStorage.setItem('payType', JSON.stringify(state.payType));
    },
    delPayType(state) {
        state.payType = [];
        sessionStorage.removeItem('payType');
    },
    setUser(state, val){
      state.user = val;
      sessionStorage.setItem('user', JSON.stringify(state.user));
    }
  },
  actions: {
  },
  modules: {
  },
  getters:{//实时监听state值得变化（最新状态）

  }
})
